import { useForm, ValidationError } from '@formspree/react';
import { useState, useEffect } from 'react';

import { Text } from '@chakra-ui/react';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ContactForm = () => {
  const [fullName, setFullName] = useState('');
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  const formUrl = process.env.NEXT_PUBLIC_CONTACT_FORM_ID;
  const [state, handleSubmit, reset] = useForm(`${formUrl}`, {
    data: {
      subject: 'Someone sent a message to drive!',
      pageTitle: function () {
        return document.title;
      },
    },
  });

  useEffect(() => {
    if (state.succeeded && !state.submitting) {
      toast('Thank you for contacting us, we will get back to you shortly!', {
        icon: '🚀',
      });
      setTimeout(() => {
        reset();
        setFullName('');
        setCompany('');
        setEmail('');
        setPhone('');
        setMessage('');
      }, 2000);
    }

    if (state.errors.length > 0) {
      toast.error('Oops, something went wrong!');
    }
  }, [state]);

  return (
    <section className={'contactForm'} id="contact-section">
      <div className={'section-wrapper flex-column'}>
        <h1>Contact Us</h1>
        <ToastContainer />
        <form
          onSubmit={handleSubmit}
          id="contactForm"
          className={'formControl'}
        >
          <div className={'formRow'}>
            <div className={'formField'}>
              <label htmlFor="fullname" className={'labelRequired'}>
                Full Name
              </label>
              <input
                id="fullname"
                type="text"
                name="fullname"
                required
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
              <ValidationError
                prefix="Name"
                field="fullname"
                errors={state.errors}
              />
            </div>

            <div className={'formField'}>
              <label htmlFor="Company" className={'labelRequired'}>
                Company Name
              </label>
              <input
                id="Company"
                type="text"
                name="Company"
                required
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              />
              <ValidationError
                prefix="Company"
                field="Company"
                errors={state.errors}
              />
            </div>
          </div>

          <div className={'formRow'}>
            <div className={'formField'}>
              <label htmlFor="email" className={'labelRequired'}>
                Email Address
              </label>
              <input
                id="email"
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
              />
            </div>
            <div className={'formField'}>
              <label htmlFor="phone" className={'labelRequired'}>
                Your phone number
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <ValidationError
                prefix="Phone"
                field="phone"
                errors={state.errors}
              />
            </div>
          </div>

          <div className={'formRow'}>
            <div className={'formField'}>
              <label htmlFor="message" className={'labelRequired'}>
                Your Message
              </label>
              <textarea
                id="message"
                name="message"
                required
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
              />
            </div>
          </div>

          <div className={'formRow'}>
            <button type="submit" disabled={state.submitting}>
              Submit
            </button>
          </div>

          <div className={'formRow'}>
            {state.errors.length >= 1 && (
              <Text mt={2} textAlign={'start'} color={'red.500'}>
                Oh no an error occurred! 😢 Please try again later.{' '}
              </Text>
            )}

            {state.succeeded && (
              <Text mt={2} textAlign={'start'} color={'green.500'}>
                Yay, thank you for joining us!
              </Text>
            )}

            {state.submitting && (
              <Text mt={2} textAlign={'start'} color={'gray.500'}>
                {"Hold on, we're submitting your email"}
              </Text>
            )}
            {!state.submitting &&
              !state.succeeded &&
              !state.errors.length >= 1 && (
                <Text mt={2} textAlign={'start'} color={'gray.500'}>
                  {"You won't receive any spam! ✌️"}
                </Text>
              )}
          </div>
        </form>
      </div>
    </section>
  );
};
